import {
  Anexo,
  ComunicacaoCliente,
  HistoricoInteracao,
  LeadContatoPlanejado,
  Orcamento,
  WorkflowDetalhe,
  WorkflowEtapa,
  WorkflowEtapaTipo,
  WorkflowStatus,
} from '../models/workflow.models';

const etapaOrder: WorkflowEtapaTipo[] = [
  WorkflowEtapaTipo.ABERTURA_OS,
  WorkflowEtapaTipo.COMPRA_PECAS,
  WorkflowEtapaTipo.PROGRAMACAO_REPARO,
  WorkflowEtapaTipo.DESMONTAGEM,
  WorkflowEtapaTipo.ANALISE_COMPLEMENTO,
  WorkflowEtapaTipo.FUNILARIA,
  WorkflowEtapaTipo.PREPARACAO,
  WorkflowEtapaTipo.PINTURA,
  WorkflowEtapaTipo.MECANICA,
  WorkflowEtapaTipo.MONTAGEM,
  WorkflowEtapaTipo.POLIMENTO,
  WorkflowEtapaTipo.LAVAGEM,
  WorkflowEtapaTipo.ACABAMENTO,
  WorkflowEtapaTipo.CONTROLE_QUALIDADE,
  WorkflowEtapaTipo.VISTORIA_SEGURADORA,
  WorkflowEtapaTipo.FINALIZADO,
];

const etapaNomes: Record<WorkflowEtapaTipo, string> = {
  [WorkflowEtapaTipo.ABERTURA_OS]: 'Abertura de OS',
  [WorkflowEtapaTipo.COMPRA_PECAS]: 'Compra de Peças',
  [WorkflowEtapaTipo.PROGRAMACAO_REPARO]: 'Programação do Reparo',
  [WorkflowEtapaTipo.DESMONTAGEM]: 'Desmontagem',
  [WorkflowEtapaTipo.ANALISE_COMPLEMENTO]: 'Análise de Complemento',
  [WorkflowEtapaTipo.FUNILARIA]: 'Funilaria',
  [WorkflowEtapaTipo.PREPARACAO]: 'Preparação',
  [WorkflowEtapaTipo.PINTURA]: 'Pintura',
  [WorkflowEtapaTipo.MECANICA]: 'Mecânica',
  [WorkflowEtapaTipo.MONTAGEM]: 'Montagem',
  [WorkflowEtapaTipo.POLIMENTO]: 'Polimento',
  [WorkflowEtapaTipo.LAVAGEM]: 'Lavagem / Higienização',
  [WorkflowEtapaTipo.ACABAMENTO]: 'Acabamento',
  [WorkflowEtapaTipo.CONTROLE_QUALIDADE]: 'Controle Qualidade Final',
  [WorkflowEtapaTipo.VISTORIA_SEGURADORA]: 'Fotos / Vistoria Seguradora',
  [WorkflowEtapaTipo.FINALIZADO]: 'Finalizado',
};

const hoursFromNow = (hours: number) => new Date(Date.now() + hours * 60 * 60 * 1000);
const daysFromNow = (days: number) => new Date(Date.now() + days * 24 * 60 * 60 * 1000);
const randInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
const pick = <T>(arr: readonly T[], index: number) => arr[index % arr.length];
const dayMs = 24 * 60 * 60 * 1000;
const addDays = (date: Date, days: number) => new Date(date.getTime() + days * dayMs);
const daysAgo = (days: number) => daysFromNow(-days);
const randomDaysAgo = (min: number, max: number) => daysAgo(randInt(min, max));
const randomDaysFromNow = (min: number, max: number) => daysFromNow(randInt(min, max));

const marcasModelos = [
  { marca: 'Volkswagen', modelos: ['Gol', 'Polo', 'Nivus', 'T-Cross'] },
  { marca: 'Fiat', modelos: ['Argo', 'Mobi', 'Pulse'] },
  { marca: 'Chevrolet', modelos: ['Onix', 'Tracker'] },
  { marca: 'Toyota', modelos: ['Corolla', 'Yaris'] },
  { marca: 'Honda', modelos: ['Civic', 'HR-V'] },
  { marca: 'Hyundai', modelos: ['HB20', 'Creta'] },
];

const clientes = [
  'Ana Souza',
  'Bruno Costa',
  'Carla Mendes',
  'Diego Alves',
  'Eduardo Braga',
  'Fernanda Luz',
  'Gabriel Nunes',
  'Helena Rocha',
  'Igor Matos',
  'Juliana Reis',
  'Karina Moreira',
  'Lucas Ferreira',
  'Marina Duarte',
  'Natalia Campos',
  'Otavio Lima',
  'Paula Araujo',
  'Rafael Almeida',
  'Sabrina Teixeira',
  'Thiago Batista',
  'Vanessa Martins',
];

const responsaveis = [
  'Carlos',
  'Fernanda',
  'Rafael',
  'Juliana',
  'Marcos',
  'Patricia',
  'Renato',
  'Camila',
  'Bruno',
  'Aline',
];

const consultores = ['Carla Mendes', 'Marcos Silva'];
const seguradoras = [
  'Porto Seguro',
  'Bradesco Seguros',
  'Allianz',
  'Tokio Marine',
  'Mapfre',
  'SulAmérica',
];
const prioridades = ['BAIXA', 'MEDIA', 'ALTA'] as const;

const checklistBase = [
  'Checklist inicial completo',
  'Pecas conferidas',
  'Equipe liberada',
  'Cliente notificado',
];

const checklistPorEtapa: Record<WorkflowEtapaTipo, string[]> = {
  [WorkflowEtapaTipo.ABERTURA_OS]: [
    'Conferir relato do sinistro',
    'Registrar abertura da OS',
    'Validar documentos',
  ],
  [WorkflowEtapaTipo.COMPRA_PECAS]: [
    'Gerar lista de peças necessárias',
    'Solicitar cotação ao fornecedor',
    'Aprovar orçamento de peças',
    'Realizar pedido',
    'Recebimento e conferência',
  ],
  [WorkflowEtapaTipo.PROGRAMACAO_REPARO]: [
    'Conferir e programar produção conforme data de entrega',
    'Definir janela de início',
    'Confirmar equipe alocada',
  ],
  [WorkflowEtapaTipo.DESMONTAGEM]: [
    'Conferir peças Orçamento',
    'Armazenar peças removidas e não substitu—das',
    'Fazer complemento Desmontagem',
  ],
  [WorkflowEtapaTipo.ANALISE_COMPLEMENTO]: [
    'Complemento Desmontagem',
    'Complemento Mecânica',
    'Complemento Funilaria',
  ],
  [WorkflowEtapaTipo.FUNILARIA]: [
    'Conferir peças Orçamento',
    'Armazenar peças em local adequado',
    'Passou pelo Controle Qualidade?',
  ],
  [WorkflowEtapaTipo.PREPARACAO]: [
    'Funilaria está OK?',
    'Conferir peças Orçamento',
    'Peças removidas: tirar foto antes de sucatear',
  ],
  [WorkflowEtapaTipo.PINTURA]: [
    'Preparação está OK?',
    'Conferir peças Orçamento',
    'Passou pelo Controle Qualidade?',
  ],
  [WorkflowEtapaTipo.MECANICA]: [
    'Pintura está OK?',
    'Conferir peças Orçamento',
    'Passou pelo Controle Qualidade?',
  ],
  [WorkflowEtapaTipo.MONTAGEM]: [
    'Mecânica está OK?',
    'Pintura está OK?',
    'Conferir peças Orçamento',
  ],
  [WorkflowEtapaTipo.POLIMENTO]: [
    'Montagem está OK?',
    'Conferir peças Orçamento',
    'Passou pelo Controle Qualidade?',
  ],
  [WorkflowEtapaTipo.LAVAGEM]: [
    'Polimento está OK?',
    'Conferir peças Orçamento',
    'Passou pelo Controle Qualidade?',
  ],
  [WorkflowEtapaTipo.ACABAMENTO]: [
    'Lavagem está OK?',
    'Conferir peças Orçamento',
    'Passou pelo Controle Qualidade?',
  ],
  [WorkflowEtapaTipo.CONTROLE_QUALIDADE]: [
    'Utilizar check-list',
    'Registrar inspeção',
    'Liberar etapa',
  ],
  [WorkflowEtapaTipo.VISTORIA_SEGURADORA]: [
    'Fotos antes/depois (evidências)',
    'Organizar documentos do processo',
    'Enviar material para seguradora',
    'Registrar retorno/aprovação',
    'Arquivar vistoria',
  ],
  [WorkflowEtapaTipo.FINALIZADO]: [
    'Check final do veículo',
    'Higienização final',
    'Cliente notificado e entrega agendada',
    'Confirmação de entrega / assinatura',
    'Encerrar atendimento',
  ],
};

const plateLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const generatePlate = (used: Set<string>) => {
  const makePlate = () => {
    const letters = Array.from({ length: 3 }, () => plateLetters[randInt(0, 25)]).join('');
    if (Math.random() > 0.5) {
      return `${letters}${randInt(0, 9)}${plateLetters[randInt(0, 25)]}${randInt(0, 9)}${randInt(0, 9)}`;
    }
    return `${letters}-${randInt(0, 9)}${randInt(0, 9)}${randInt(0, 9)}${randInt(0, 9)}`;
  };

  let plate = makePlate();
  while (used.has(plate)) {
    plate = makePlate();
  }
  used.add(plate);
  return plate;
};

const generateSinistroNumero = (seed: number) =>
  `SIN-${new Date().getFullYear()}-${String(seed).padStart(6, '0')}`;

const createEtapas = (
  etapaAtual: WorkflowEtapaTipo,
  responsavelAtual: string,
  statusGeral: WorkflowStatus,
  baseStart: Date,
  atrasoDias?: number,
): WorkflowEtapa[] => {
  const currentIndex = etapaOrder.indexOf(etapaAtual);
  const stepSpan = 2;
  return etapaOrder.map((tipo, index) => {
    const concluido = statusGeral === 'CONCLUIDO' ? index <= currentIndex : index < currentIndex;
    const isAtual = index === currentIndex;
    const previstaInicio = addDays(baseStart, index * stepSpan);
    const previstaFim = addDays(baseStart, index * stepSpan + 1);
    const inicio = concluido || isAtual ? previstaInicio : undefined;
    const fim = concluido || (statusGeral === 'CONCLUIDO' && isAtual) ? previstaFim : undefined;

    const anexos: Anexo[] = [];
    if (isAtual && Math.random() > 0.5) {
      anexos.push({
        id: Date.now() + index,
        nomeArquivo: 'documento-etapa.pdf',
        etapa: tipo,
        anexadoPor: responsavelAtual,
        dataHora: daysFromNow(-1),
      });
    }

    const checklistSource = checklistPorEtapa[tipo] ?? checklistBase;
    return {
      tipo,
      nome: etapaNomes[tipo],
      previstaInicio,
      previstaFim,
      inicio,
      fim,
      checklist: isAtual
        ? checklistSource.map((texto, idx) => ({ id: idx + 1, texto, ok: idx === 0 }))
        : Math.random() > 0.6
          ? checklistSource
              .slice(0, randInt(1, Math.min(3, checklistSource.length)))
              .map((texto, idx) => ({
                id: idx + 1,
                texto,
                ok: true,
              }))
          : [],
      observacoes: isAtual
        ? ['Equipe alinhada para esta etapa.', 'Prazo monitorado pelo consultor.'].slice(
            0,
            randInt(0, 2),
          )
        : [],
      anexos,
      responsavel: responsavelAtual,
      concluido,
    };
  });
};

const createHistorico = (workflowId: number, responsavel: string): HistoricoInteracao[] => [
  {
    id: workflowId * 10 + 1,
    workflowId,
    dataHora: daysFromNow(-5),
    tipo: 'SISTEMA',
    descricao: 'Workflow criado a partir da OS.',
    usuario: 'Sistema',
  },
  {
    id: workflowId * 10 + 2,
    workflowId,
    dataHora: daysFromNow(-3),
    tipo: 'MUDANCA_ETAPA',
    descricao: 'Avanco para etapa atual.',
    usuario: responsavel,
  },
];

const createComunicacoes = (workflowId: number): ComunicacaoCliente[] => [
  {
    id: workflowId * 20 + 1,
    workflowId,
    canal: 'WHATSAPP',
    para: '(11) 98888-1234',
    mensagem: 'Seu veiculo entrou na etapa de reparo. Seguimos com novidades.',
    dataHora: daysFromNow(-2),
    statusEnvio: 'ENVIADO',
  },
  {
    id: workflowId * 20 + 2,
    workflowId,
    canal: 'EMAIL',
    para: 'cliente@example.com',
    mensagem: 'Previsao de entrega atualizada. Qualquer duvida, fale conosco.',
    dataHora: daysFromNow(-1),
    statusEnvio: 'PENDENTE',
  },
];

const createWorkflow = (
  id: number,
  osNumero: string,
  placa: string,
  marca: string,
  modelo: string,
  clienteNome: string,
  clienteTelefone: string,
  clienteEmail: string,
  seguradoraNome: string,
  sinistroNumero: string,
  consultorResponsavel: string,
  responsavelAtual: string,
  etapaAtual: WorkflowEtapaTipo,
  statusGeral: WorkflowStatus,
  createdDaysAgo: number,
  atrasoDias?: number,
): WorkflowDetalhe => {
  const criadoEm = daysFromNow(-createdDaysAgo);
  const fase = createdDaysAgo <= 3 ? 'OS' : 'EXECUCAO';
  const ultimoContatoEm = daysFromNow(-randInt(1, 4));
  const proximoContatoEm =
    statusGeral === 'ATRASADO' ? daysFromNow(randInt(0, 2)) : daysFromNow(randInt(1, 3));
  const dataPrevistaEntrega =
    statusGeral === 'ATRASADO'
      ? daysFromNow(-(atrasoDias ?? randInt(2, 6)))
      : daysFromNow(randInt(2, 12));
  const diasNaEtapaAtual =
    statusGeral === 'ATRASADO' ? (atrasoDias ?? randInt(3, 8)) + randInt(1, 3) : randInt(1, 6);
  const currentIndex = etapaOrder.indexOf(etapaAtual);
  const stepSpan = 2;
  const baseStart =
    statusGeral === 'ATRASADO'
      ? daysAgo(currentIndex * stepSpan + 1 + (atrasoDias ?? 3))
      : statusGeral === 'CONCLUIDO'
        ? daysAgo(currentIndex * stepSpan + 3)
        : daysAgo(Math.max(currentIndex * stepSpan - 1, 0));
  return {
    id,
    osNumero,
    placa,
    marca,
    modelo,
    clienteNome,
    clienteTelefone,
    clienteEmail,
    seguradoraNome,
    sinistroNumero,
    consultorResponsavel,
    responsavelAtual,
    etapaAtual,
    statusGeral,
    criadoEm,
    fase,
    ultimoContatoEm,
    proximoContatoEm,
    dataPrevistaEntrega,
    diasNaEtapaAtual,
    atrasoDias,
    etapas: createEtapas(etapaAtual, responsavelAtual, statusGeral, baseStart, atrasoDias),
    historico: createHistorico(id, responsavelAtual),
    comunicacoes: createComunicacoes(id),
  };
};

const generateWorkflows = (): WorkflowDetalhe[] => {
  const workflows: WorkflowDetalhe[] = [];
  const usedPlates = new Set<string>();
  let idCounter = 200;
  let osCounter = 1;

  etapaOrder.forEach((etapa, etapaIndex) => {
    const count = randInt(3, 6);
    const atrasadoIndex = randInt(0, count - 1);

    for (let i = 0; i < count; i += 1) {
      const status: WorkflowStatus =
        etapa === WorkflowEtapaTipo.FINALIZADO
          ? 'CONCLUIDO'
          : i === atrasadoIndex
            ? 'ATRASADO'
            : 'EM_ANDAMENTO';
      const atrasoDias = status === 'ATRASADO' ? randInt(3, 10) : undefined;
      const createdDaysAgo = randInt(6, 20);

      const marcaModel = pick(marcasModelos, etapaIndex + i);
      const modelo = pick(marcaModel.modelos, etapaIndex + i + 1);

      workflows.push(
        createWorkflow(
          idCounter,
          `OS-2026-${String(osCounter).padStart(6, '0')}`,
          generatePlate(usedPlates),
          marcaModel.marca,
          modelo,
          pick(clientes, idCounter),
          '(11) 98888-1234',
          'cliente@example.com',
          pick(seguradoras, idCounter),
          generateSinistroNumero(idCounter),
          pick(consultores, idCounter),
          pick(responsaveis, idCounter),
          etapa,
          status,
          createdDaysAgo,
          atrasoDias,
        ),
      );

      idCounter += 1;
      osCounter += 1;
    }
  });

  return workflows;
};

const countByStage = (workflows: WorkflowDetalhe[]) => {
  const counts: Record<string, number> = {};
  etapaOrder.forEach((etapa) => {
    counts[etapa] = workflows.filter((wf) => wf.etapaAtual === etapa).length;
  });
  console.log('[Seed] Workflows por etapa:', counts, 'Total:', workflows.length);
  return counts;
};

export const SEED_VERSION = 5;

export const buildSeedData = () => {
  const usedPlates = new Set<string>();
  let leadId = 100;
  const atendimentoStatus = [
    'Aberto',
    'Aberto',
    'Aguardando retorno',
    'Aguardando retorno',
    'Efetuar Contato',
    'Efetuar Contato',
    'Perdido',
    'Perdido',
    'Ganho',
    'Ganho',
    'Aberto',
    'Ganho',
  ] as const;

  const motivosPerda = [
    'Sem retorno',
    'Preco',
    'Fechou com concorrente',
    'Nao trouxe documentacao',
    'Sem autorizacao da seguradora',
  ] as const;

  let abertoComPromessa = false;
  let ganhoComFollowup = false;

  const leads: Orcamento[] = atendimentoStatus.map((statusAtendimento, index) => {
    const marcaModel = pick(marcasModelos, index);
    const modelo = pick(marcaModel.modelos, index + 1);
    const consultor = pick(consultores, index);
    const valorOrcamento = randInt(3000, 6000);

    let criadoEm = new Date();
    let ultimoContatoEm: Date | null = null;
    let proximoContatoEm: Date | null = null;
    let dataPrevistaEntrega: Date | null = null;
    let motivoPerda: string | null = null;
    let prioridade: 'BAIXA' | 'MEDIA' | 'ALTA' = 'MEDIA';

    if (statusAtendimento === 'Aberto') {
      criadoEm = randomDaysAgo(1, 7);
      ultimoContatoEm = Math.random() > 0.5 ? randomDaysAgo(3, 7) : null;
      proximoContatoEm = randomDaysFromNow(1, 3);
      prioridade = Math.random() > 0.5 ? 'MEDIA' : 'ALTA';
      if (!abertoComPromessa) {
        dataPrevistaEntrega = randomDaysFromNow(10, 20);
        abertoComPromessa = true;
      }
    }

    if (statusAtendimento === 'Aguardando retorno') {
      criadoEm = randomDaysAgo(3, 12);
      ultimoContatoEm = randomDaysAgo(1, 4);
      proximoContatoEm = randomDaysFromNow(0, 2);
      prioridade = 'MEDIA';
    }

    if (statusAtendimento === 'Efetuar Contato') {
      criadoEm = randomDaysAgo(5, 20);
      ultimoContatoEm = Math.random() > 0.2 ? randomDaysAgo(5, 15) : null;
      proximoContatoEm = randomDaysFromNow(0, 1);
      prioridade = 'ALTA';
    }

    if (statusAtendimento === 'Perdido') {
      criadoEm = randomDaysAgo(10, 40);
      ultimoContatoEm = randomDaysAgo(5, 25);
      proximoContatoEm = null;
      motivoPerda = pick(motivosPerda, index);
      prioridade = 'BAIXA';
    }

    if (statusAtendimento === 'Ganho') {
      criadoEm = randomDaysAgo(2, 25);
      ultimoContatoEm = randomDaysAgo(0, 3);
      proximoContatoEm = !ganhoComFollowup ? daysFromNow(1) : null;
      ganhoComFollowup = true;
      dataPrevistaEntrega = randomDaysFromNow(3, 15);
      prioridade = 'MEDIA';
    }

    const statusLead =
      statusAtendimento === 'Perdido' || statusAtendimento === 'Ganho' ? 'FECHADO' : 'ABERTO';
    const daysSinceCreated = Math.max(1, Math.floor((Date.now() - criadoEm.getTime()) / dayMs));
    const fechamentoDias =
      statusLead === 'FECHADO' ? randInt(1, Math.min(10, daysSinceCreated)) : 0;
    const dataFechamento = statusLead === 'FECHADO' ? daysAgo(fechamentoDias) : null;
    const fase =
      statusAtendimento === 'Ganho'
        ? 'OS'
        : statusAtendimento === 'Perdido'
          ? 'CANCELADO'
          : 'ORCAMENTO';

    return {
      id: leadId + index,
      codigoExterno: index % 2 === 0 ? `LEG-${String(leadId + index).padStart(6, '0')}` : undefined,
      placa: generatePlate(usedPlates),
      marca: marcaModel.marca,
      modelo,
      valor: valorOrcamento,
      valorOrcamento,
      consultorResponsavel: consultor,
      consultor,
      status: 'LEAD',
      statusLead,
      statusAtendimento,
      clienteNome: pick(clientes, index + 3),
      clienteTelefone: '(11) 98888-0000',
      clienteEmail: 'cliente@email.com',
      criadoEm,
      dataCriacao: criadoEm,
      dataFechamento,
      virouOs: statusAtendimento === 'Ganho',
      seguradoraNome: pick(seguradoras, index),
      sinistroNumero: generateSinistroNumero(leadId + index),
      fase,
      ultimoContatoEm,
      proximoContatoEm,
      motivoPerda,
      dataPrevistaEntrega,
      responsavelAtual: consultor,
      prioridade,
    };
  });

  const orcamentos: Orcamento[] = [...leads];

  const contatos: LeadContatoPlanejado[] = leads
    .filter((lead) => lead.statusLead === 'ABERTO')
    .map((lead, index) => ({
      id: 1 + index,
      orcamentoId: lead.id,
      dataHora: hoursFromNow(randInt(1, 6)),
      canal: pick(['WHATSAPP', 'EMAIL', 'LIGACAO'] as LeadContatoPlanejado['canal'][], index),
      assunto: `Contato Lead ${lead.placa}`,
      observacao: 'Retorno agendado',
      concluido: false,
    }));

  const workflows = generateWorkflows();
  countByStage(workflows);

  return { orcamentos, contatos, workflows };
};
